import React, { forwardRef } from 'react';
import { Controller } from 'react-hook-form';

export const FormFileUploader = forwardRef(
  ({ name, control, children, accept, multiple = false, dataTestId, rules, error }, ref) => {
    return (
      <Controller
        control={control}
        name={name}
        rules={rules}
        error={error}
        render={({ field }) => (
          <div>
            {children}
            <input
              type='file'
              name={field.name}
              onBlur={field.onBlur}
              onChange={(e) => {
                const files = e.target.files;
                if (multiple) {
                  field.onChange(Array.from(files || []));
                } else {
                  field.onChange(files?.[0] || null);
                }
              }}
              ref={ref}
              accept={accept}
              multiple={multiple}
              hidden
              data-testid={dataTestId}
            />
          </div>
        )}
      />
    );
  },
);

FormFileUploader.displayName = 'FormFileUploader';
